import { useNavigate } from 'react-router-dom';

export default function MobileBottomNav() {
  const navigate = useNavigate();

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-xl border-t border-background-200 safe-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {[
          { icon: 'ri-home-5-line', label: 'Inicio', href: '#inicio' },
          { icon: 'ri-compass-3-line', label: 'Explorar', href: '#explorar' },
          { icon: 'ri-search-line', label: 'Buscar', href: '/buscar', isRoute: true },
          { icon: 'ri-radio-line', label: 'Radios', href: '#destacadas' },
          { icon: 'ri-smartphone-line', label: 'App', href: '/app', isRoute: true },
        ].map((item) => (
          item.isRoute ? (
            <button
              key={item.label}
              onClick={() => navigate(item.href)}
              className="flex flex-col items-center gap-1 text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer py-1 px-2"
            >
              <i className={`${item.icon} text-lg`}></i>
              <span className="text-[10px] font-medium">{item.label}</span>
            </button>
          ) : (
            <a
              key={item.label}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleClick(item.href); }}
              className="flex flex-col items-center gap-1 text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer py-1 px-2"
            >
              <i className={`${item.icon} text-lg`}></i>
              <span className="text-[10px] font-medium">{item.label}</span>
            </a>
          )
        ))}
      </div>
    </nav>
  );
}